module.exports = __webpack_public_path__ + "img/Pavlodar_obl.4cf7a123.png";